export const MAX_FILE_SIZE = 1024 * 1024 * 20

export const MAX_FILE_SIZE_MB = (MAX_FILE_SIZE / (1024 * 1024)).toFixed(0)

// Kept here rather than in LogEmailComposser so `utils.ts` can use it without
// creating an import cycle between the two modules.
export const LogMailType = {
  incoming: 'incoming' as string,
  outgoing: 'outgoing' as string,
} as const
